module.exports = __webpack_public_path__ + "img/second-day-1.46c1f8c8.png";